<script setup>
function navigate(value) {
    window.location = value
}
</script>

<template>
    <slot v-bind="{ navigate }"></slot>
</template>c

<style lang="scss">
@use "@/scss/framework" as *;

@layer components.site-switcher {
    .site-switcher {

    }
}
</style>
